import React from 'react';
export function PainPoints() {
  const points = [{
    title: 'Noches en vela:',
    desc: '"Traduciendo" teoría densa a lenguaje que un adolescente no ignore.'
  }, {
    title: 'Efecto Zombie:',
    desc: 'Alumnos que sienten que la economía no tiene nada que ver con ellos.'
  }, {
    title: 'Fraude ChatGPT:',
    desc: 'Evaluaciones que todos aprueban con IA pero nadie entiende.'
  }, {
    title: 'Silencios incómodos:',
    desc: 'Preguntas sobre Cripto, Apuestas o Trading para las que no tenés respuesta.'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-dark" data-id="element-142">
      <div className="max-w-3xl mx-auto" data-id="element-143">
        <h2 className="text-lg md:text-2xl font-black text-center mb-4 text-white leading-tight uppercase" data-id="element-144">
          ¿Te suena conocido esto?
        </h2>

        <div className="bg-brand-card border border-white/10 rounded-lg p-5 mb-5 space-y-3 text-sm md:text-base text-gray-300 font-medium leading-relaxed" data-id="element-145">
          <p data-id="element-146">
            <span className="text-brand-accent font-black" data-id="element-147">
              Domingo, 11 pm.
            </span>{' '}
            Mañana primera hora y seguís buscando cómo explicar finanzas sin que
            tus alumnos se duerman o se pongan a mirar TikTok.
          </p>
          <p className="text-white font-bold" data-id="element-148">
            No es tu culpa. Es que peleás con herramientas del siglo pasado.
          </p>
        </div>

        <p className="text-center text-white font-black uppercase mb-4 text-sm md:text-base" data-id="element-149">
          El costo de no tener el material correcto:
        </p>

        <div className="bg-brand-card border-l-4 border-red-500 p-4 md:p-5 rounded-r-lg mb-5 shadow-[0_0_15px_rgba(239,68,68,0.15)]" data-id="element-150">
          <div className="space-y-3" data-id="element-151">
            {points.map((point, index) => <div key={index} className="flex items-start" data-id="element-152">
                <span className="text-red-500 mr-3 shrink-0 mt-0.5 text-base" data-id="element-153">
                  🔴
                </span>
                <p className="text-sm md:text-base text-gray-200 font-bold leading-relaxed" data-id="element-154">
                  <span className="text-white font-black" data-id="element-155">{point.title}</span>{' '}
                  {point.desc}
                </p>
              </div>)}
          </div>
        </div>

        <div className="bg-brand-card border border-brand-accent/40 rounded-lg p-5 text-center space-y-2 shadow-[0_0_25px_rgba(34,197,94,0.12)]" data-id="element-156">
          <p className="text-white font-black text-base md:text-lg uppercase leading-tight" data-id="element-157">
            Basta de regalar tus fines de semana. Tu dedicación ya la tenés,
            ahora te falta la{' '}
            <span className="text-brand-accent neon-glow" data-id="element-158">herramienta</span>.
          </p>
          <p className="text-brand-accent font-black text-lg md:text-xl uppercase tracking-wider pt-1" data-id="element-159">
            Planificá todo tu año hoy.
          </p>
        </div>
      </div>
    </section>;
}